import { render, staticRenderFns } from "./ExchangeRates.vue?vue&type=template&id=b3930f12"
import script from "./ExchangeRates.vue?vue&type=script&lang=js"
export * from "./ExchangeRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports